import { render } from "./TeamSetup.vue?vue&type=template&id=4831db96&scoped=true"
import script from "./TeamSetup.vue?vue&type=script&lang=js"
export * from "./TeamSetup.vue?vue&type=script&lang=js"

import "./TeamSetup.vue?vue&type=style&index=0&id=4831db96&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4831db96"]])

export default __exports__